<template>
    <div class="card mb-1 compact-price-row">
        <div class="card-body p-2">
            <div class="row align-items-center">
                <div class="col-12 col-sm-2 retailer-logo d-flex align-items-center">
                    <template v-if="price.retailer.logo">
                        <a :href="`/retailers/${price.retailer.id}`">
                            <img :src="`/retailer-images${price.retailer.logo}`" alt="Retailer logo" class="img-fluid" />
                        </a>
                        <button class="btn btn-link p-0 ms-2" type="button" data-bs-toggle="collapse" :data-bs-target="`#collapse-${index}`" aria-expanded="false" :aria-controls="`collapse-${index}`">
                            <font-awesome-icon icon="fa-solid fa-chevron-down" />
                        </button>
                    </template>
                </div>
                <div class="col-12 col-sm-2 stock-info">
                    <p v-if="price.stock_info == 'In stock'" class="text-success mb-0">
                        <font-awesome-icon v-tooltip="`På lager`" icon="fa-solid fa-circle-check" /> På lager
                    </p>
                    <p v-else class="text-danger mb-0">
                        <font-awesome-icon icon="fa-solid fa-circle-xmark" v-tooltip="`Ikke på lager`" /> Ikke på lager
                    </p>
                </div>
                <div class="col-12 col-sm-2 lead-time">
                    <span class="small">{{ Math.round(price.lead_time_calculated_first) }} dag(e)</span>
                </div>
                <div class="col-12 col-sm-2 price-info text-end">
                    <h5 class="text-primary mb-0">{{ numberFormat(price.price_with_shipping_min) }}</h5>
                    <small class="text-muted">INKL. FRAGT</small>
                </div>
                <div class="col-12 col-sm-2 price-breakdown text-end">
                    <div class="d-flex flex-column align-items-end">
                        <div>
                            <small class="text-muted ms-1 text-uppercase">PRODUKT </small>
                            <h6 class="text-secondary mb-0 d-inline fw-bold text-primary">{{ numberFormat(price.price) }}</h6>
                        </div>
                        <div class="mt-1">
                            <small class="text-muted ms-1 text-uppercase">FRAGT </small>
                            <h6 class="text-secondary mb-0 d-inline fw-bold text-success">{{ numberFormat(price.lowest_shipping_cost) }}</h6>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-2 action-link text-end">
                    <a target="_blank" rel="noopener nofollow" :href="`/redirect/${productId}/${price.price_guid}`" class="btn btn-sm btn-pricecompare-primary">Gå til butik</a>
                </div>
            </div>
            <div :id="`collapse-${index}`" class="collapse">
                <div class="mt-3 retailer-info">
                    <div class="rating mb-3">
                        <strong>Vurdering:</strong>
                        <span class="badge bg-success">4.5/5</span>
                    </div>
                    <div class="payment-options mb-3">
                        <strong>Betalingsmuligheder:</strong>
                        <div class="d-flex gap-2 mt-2">
                            <img src="/images/icons/visa.png" alt="Visa" class="payment-icon" />
                            <img src="/images/icons/mastercard.png" alt="Mastercard" class="payment-icon" />
                            <img src="/images/icons/paypal.png" alt="PayPal" class="payment-icon" />
                        </div>
                    </div>
                    <div class="shipping-options">
                        <strong>Fragtmuligheder:</strong>
                        <div class="d-flex gap-2 mt-2">
                            <img src="/images/icons/standard-shipping.png" alt="Standard" class="shipping-icon" />
                            <img src="/images/icons/express-shipping.png" alt="Express" class="shipping-icon" />
                            <img src="/images/icons/home-delivery.png" alt="Hjemmelevering" class="shipping-icon" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    price: {
        type: Object,
        required: true
    },
    index: {
        type: Number,
        required: true
    },
    productId: {
        type: String,
        required: true
    }
});

function numberFormat(value) {
    value = Number(value);
    return new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
}
</script>

<style scoped>
.compact-price-row {
    padding: 0.5rem;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
}

.retailer-logo img {
    height: 40px;
}

.stock-info {
    font-size: 0.9rem;
}

.lead-time {
    font-size: 0.8rem;
    color: #6c757d;
}

.price-info {
    text-align: right;
}

.price-info h5 {
    font-size: 1rem;
    margin-bottom: 0;
}

.price-breakdown {
    text-align: right;
}

.price-breakdown h6 {
    font-size: 0.9rem;
    margin-bottom: 0;
}

.action-link .btn {
    font-size: 0.8rem;
    padding: 0.25rem 0.5rem;
}

.retailer-info {
    font-size: 0.9rem;
    color: #333;
}

.rating .badge {
    font-size: 0.9rem;
}

.payment-icon, .shipping-icon {
    width: 32px;
    height: 32px;
    border-radius: 4px;
    border: 1px solid #dee2e6;
    padding: 4px;
    background-color: #f8f9fa;
}
</style>